import React, { useEffect, useRef, useState } from 'react';
import { formatRating, formatReviewCount } from '../../helpers/rating';
import useOnScreen from '../../services/hooks/useOnScreen';
import SortReviews from './sort-reviews';
import Review from '../review';
import SvgStar from 'src/assets/svg/SvgStar.svg';

const useGetSpotReviews = require('../../services/hooks/useGetSpotReviews');

const perPage = 10;

const AllReviews = ({
    reviewsCount,
    rating,
    userDetails,
    spotId,
    host,
    sortReviews,
    changeSort,
    isMobile,
    useAddReplySSR,
    useDeleteReplySSR,
    useHandleUpvoteSSR,
    sortBy,
    isSpotDetail,
    handleSniffpassReviewBadge,
    spot,
    noRichText,
}) => {
    const { getSpotReviews, reviews, loading } = typeof window === 'undefined' ? {} : useGetSpotReviews.default();
    const [limit, setLimit] = useState(perPage);
    const [allReviews, setAllReviews] = useState([]);
    const [modalSortOpen, setModalSortOpen] = useState(false);
    const myRef = useRef(null);
    const isVisible = useOnScreen(myRef);

    useEffect(() => {
        if (!isVisible || limit === reviewsCount) {
            return;
        }
        const newLimit = limit + perPage >= reviewsCount ? reviewsCount : limit + perPage;
        getSpotReviews({
            variables: {
                id: spotId,
                first: newLimit,
                sortBy: sortReviews.sortBy,
                sortOrder: sortReviews.sortOrder,
            },
        });
        setLimit(newLimit);
    }, [isVisible]);

    useEffect(() => {
        if (reviews) {
            setAllReviews(reviews);
        }
    }, [reviews]);

    useEffect(() => {
        setLimit(perPage);
        getSpotReviews({
            variables: {
                id: spotId,
                first: perPage,
                sortBy: sortReviews.sortBy,
                sortOrder: sortReviews.sortOrder,
            },
        });
    }, [sortReviews]);

    const toggleModalSortOpen = () => setModalSortOpen(!modalSortOpen);

    const handleModalSortChange = (v) => {
        changeSort(v);
        setModalSortOpen(false);
    };

    return (
        <div className="comments">
            <div className="rev-head">
                <div className="snif-m1 snif-semibold mt-2 mb-3">
                    <SvgStar className="star-reviews" /> {formatRating(rating)}
                    <span className="reviews-count snif-medium">{` (${formatReviewCount(reviewsCount)} Reviews)`}</span>
                </div>
            </div>
            <SortReviews
                {...{
                    toggleSortOpen: toggleModalSortOpen,
                    sortOpen: modalSortOpen,
                    onChangeSort: handleModalSortChange,
                    sortReviews,
                }}
            />
            {allReviews.length > 0 &&
                allReviews.map((review, i) => (
                    <Review
                        key={i}
                        {...{
                            ...review,
                            host,
                            spot,
                            sortBy,
                            spotId,
                            isMobile,
                            changeSort,
                            userDetails,
                            isSpotDetail,
                            useAddReplySSR,
                            useDeleteReplySSR,
                            useHandleUpvoteSSR,
                            handleSniffpassReviewBadge,
                            noRichText,
                        }}
                    />
                ))}
            <div ref={myRef} />
            {loading && (
                <div className="col-md-12 mb-3 text-center">
                    <div className="loading" />
                </div>
            )}
        </div>
    );
};

export default AllReviews;
